import { render, staticRenderFns } from "./OriginalDataHeader.vue?vue&type=template&id=53a8faa6&scoped=true&"
import script from "./OriginalDataHeader.vue?vue&type=script&lang=ts&"
export * from "./OriginalDataHeader.vue?vue&type=script&lang=ts&"
import style0 from "./OriginalDataHeader.vue?vue&type=style&index=0&id=53a8faa6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a8faa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VBtn,VIcon,VTooltip})
